export default theme => ({
  root: {},
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: '2rem',
  },
  postedOn: {
    display: 'flex',
    alignItems: 'center',
  },
  postedOnLabel: {
    marginRight: '1rem',
  },
  noResults: {
    width: '100%',
    padding: '3rem',
    marginBottom: '3rem',
    marginTop: '8px',
    textAlign: 'center',
    background: theme.palette.white.main,
    color: theme.palette.black.dark,
  },
});
